<template>
  <h1>401</h1>
</template>

<script>
export default {
  name: "Page401"
};
</script>

<style></style>
